const COLOR = {
  applegreen100: {
    name: 'applegreen100',
    color: '#f4ffee'
  },
  applegreen200: {
    name: 'applegreen200',
    color: '#e1fdd3'
  },
  applegreen300: {
    name: 'applegreen300',
    color: '#b0f58f'
  },
  applegreen400: {
    name: 'applegreen400',
    color: '#70e85c'
  },
  applegreen500: {
    name: 'applegreen500',
    color: '#1cc519'
  },
  applegreen600: {
    name: 'applegreen600',
    color: '#05a502'
  },
  black: {
    name: 'black',
    color: '#000000'
  },
  blackalpha05: {
    name: 'blackalpha05',
    color: 'rgba(#000000, 0.05)'
  },
  blackalpha10: {
    name: 'blackalpha10',
    color: 'rgba(#000000, 0.10)'
  },
  blackalpha15: {
    name: 'blackalpha15',
    color: 'rgba(#000000, 0.15)'
  },
  blackalpha20: {
    name: 'blackalpha20',
    color: 'rgba(#000000, 0.20)'
  },
  blackalpha50: {
    name: 'blackalpha50',
    color: 'rgba(#000000, 0.50)'
  },
  blackalpha60: {
    name: 'blackalpha60',
    color: 'rgba(#000000, 0.60)'
  },
  blue100: {
    name: 'blue100',
    color: '#eff8ff'
  },
  blue200: {
    name: 'blue200',
    color: '#deeeff'
  },
  blue300: {
    name: 'blue300',
    color: '#97d3ff'
  },
  blue400: {
    name: 'blue400',
    color: '#34aaff'
  },
  blue500: {
    name: 'blue500',
    color: '#007eff'
  },
  blue600: {
    name: 'blue600',
    color: '#0066ce'
  },
  brown100: {
    name: 'brown100',
    color: '#fffaf4'
  },
  brown200: {
    name: 'brown200',
    color: '#fdf0e3'
  },
  brown300: {
    name: 'brown300',
    color: '#ffc38b'
  },
  brown400: {
    name: 'brown400',
    color: '#e28630'
  },
  brown500: {
    name: 'brown500',
    color: '#bb6310'
  },
  brown600: {
    name: 'brown600',
    color: '#96510f'
  },
  cyan100: {
    name: 'cyan100',
    color: '#edfcff'
  },
  cyan200: {
    name: 'cyan200',
    color: '#d5f7f9'
  },
  cyan300: {
    name: 'cyan300',
    color: '#94f1fa'
  },
  cyan400: {
    name: 'cyan400',
    color: '#48e5ef'
  },
  cyan500: {
    name: 'cyan500',
    color: '#00a3ba'
  },
  cyan600: {
    name: 'cyan600',
    color: '#018293'
  },
  darkgray100: {
    name: 'darkgray100',
    color: '#edf2f9'
  },
  darkgray200: {
    name: 'darkgray200',
    color: '#dce2ed'
  },
  darkgray300: {
    name: 'darkgray300',
    color: '#718095'
  },
  darkgray400: {
    name: 'darkgray400',
    color: '#48525b'
  },
  darkgray500: {
    name: 'darkgray500',
    color: '#2e343a'
  },
  darkgray600: {
    name: 'darkgray600',
    color: '#24282c'
  },
  deeporange100: {
    name: 'deeporange100',
    color: '#fff5f1'
  },
  deeporange200: {
    name: 'deeporange200',
    color: '#ffece6'
  },
  deeporange300: {
    name: 'deeporange300',
    color: '#fecebf'
  },
  deeporange400: {
    name: 'deeporange400',
    color: '#ff784d'
  },
  deeporange500: {
    name: 'deeporange500',
    color: '#ff5924'
  },
  deeporange600: {
    name: 'deeporange600',
    color: '#ea420d'
  },
  deeppurple100: {
    name: 'deeppurple100',
    color: '#f9f7ff'
  },
  deeppurple200: {
    name: 'deeppurple200',
    color: '#ece7ff'
  },
  deeppurple300: {
    name: 'deeppurple300',
    color: '#c6b7ff'
  },
  deeppurple400: {
    name: 'deeppurple400',
    color: '#8465ff'
  },
  deeppurple500: {
    name: 'deeppurple500',
    color: '#6c3ef0'
  },
  deeppurple600: {
    name: 'deeppurple600',
    color: '#5833c1'
  },
  forest100: {
    name: 'forest100',
    color: '#ecfdf5'
  },
  forest200: {
    name: 'forest200',
    color: '#d5fbe9'
  },
  forest300: {
    name: 'forest300',
    color: '#8ff1c2'
  },
  forest400: {
    name: 'forest400',
    color: '#19cf87'
  },
  forest500: {
    name: 'forest500',
    color: '#00a470'
  },
  forest600: {
    name: 'forest600',
    color: '#008a57'
  },
  gray100: {
    name: 'gray100',
    color: '#f6f8fa'
  },
  gray150: {
    name: 'gray150',
    color: '#f3f5f7'
  },
  gray200: {
    name: 'gray200',
    color: '#edeff2'
  },
  gray250: {
    name: 'gray250',
    color: '#dcdee0'
  },
  gray300: {
    name: 'gray300',
    color: '#c8cacc'
  },
  gray400: {
    name: 'gray400',
    color: '#bbbbbd'
  },
  gray500: {
    name: 'gray500',
    color: '#aaaaac'
  },
  gray600: {
    name: 'gray600',
    color: '#929294'
  },
  gray700: {
    name: 'gray700',
    color: '#767678'
  },
  gray800: {
    name: 'gray800',
    color: '#404048'
  },
  gray900: {
    name: 'gray900',
    color: '#1e1e23'
  },
  green100: {
    name: 'green100',
    color: '#eefff2'
  },
  green200: {
    name: 'green200',
    color: '#defae4'
  },
  green300: {
    name: 'green300',
    color: '#91f2ad'
  },
  green400: {
    name: 'green400',
    color: '#00cd60'
  },
  green500: {
    name: 'green500',
    color: '#09ab49'
  },
  green600: {
    name: 'green600',
    color: '#009e3f'
  },
  indigo100: {
    name: 'indigo100',
    color: '#f1f4ff'
  },
  indigo200: {
    name: 'indigo200',
    color: '#e6ecff'
  },
  indigo300: {
    name: 'indigo300',
    color: '#a7c0ff'
  },
  indigo400: {
    name: 'indigo400',
    color: '#5a7eff'
  },
  indigo500: {
    name: 'indigo500',
    color: '#3461ff'
  },
  indigo600: {
    name: 'indigo600',
    color: '#2249d2'
  },
  lemonyellow100: {
    name: 'lemonyellow100',
    color: '#ffffef'
  },
  lemonyellow200: {
    name: 'lemonyellow200',
    color: '#feffc9'
  },
  lemonyellow300: {
    name: 'lemonyellow300',
    color: '#fdff8c'
  },
  lemonyellow400: {
    name: 'lemonyellow400',
    color: '#fbff35'
  },
  lemonyellow500: {
    name: 'lemonyellow500',
    color: '#fff500'
  },
  lemonyellow600: {
    name: 'lemonyellow600',
    color: '#dbd30a'
  },
  lightblue100: {
    name: 'lightblue100',
    color: '#edf9ff'
  },
  lightblue200: {
    name: 'lightblue200',
    color: '#d4f5ff'
  },
  lightblue300: {
    name: 'lightblue300',
    color: '#87e2ff'
  },
  lightblue400: {
    name: 'lightblue400',
    color: '#3ec5ff'
  },
  lightblue500: {
    name: 'lightblue500',
    color: '#0097f5'
  },
  lightblue600: {
    name: 'lightblue600',
    color: '#007ad3'
  },
  navergreen: {
    name: 'navergreen',
    color: '#03c75a'
  },
  neongreen100: {
    name: 'neongreen100',
    color: '#ebfff0'
  },
  neongreen200: {
    name: 'neongreen200',
    color: '#c7ffd6'
  },
  neongreen500: {
    name: 'neongreen500',
    color: '#3ce085'
  },
  neongreen600: {
    name: 'neongreen600',
    color: '#18d46c'
  },
  npaygreen: {
    name: 'npaygreen',
    color: '#00de5a'
  },
  olive100: {
    name: 'olive100',
    color: '#f8feed'
  },
  olive200: {
    name: 'olive200',
    color: '#f0fdd4'
  },
  olive300: {
    name: 'olive300',
    color: '#ddfc9a'
  },
  olive400: {
    name: 'olive400',
    color: '#ade74e'
  },
  olive500: {
    name: 'olive500',
    color: '#81c80e'
  },
  olive600: {
    name: 'olive600',
    color: '#68a20a'
  },
  orange100: {
    name: 'orange100',
    color: '#fff8f0'
  },
  orange200: {
    name: 'orange200',
    color: '#ffeedb'
  },
  orange300: {
    name: 'orange300',
    color: '#ffd19e'
  },
  orange400: {
    name: 'orange400',
    color: '#ff9c41'
  },
  orange500: {
    name: 'orange500',
    color: '#ff8a00'
  },
  orange600: {
    name: 'orange600',
    color: '#ec6809'
  },
  purple100: {
    name: 'purple100',
    color: '#fef5ff'
  },
  purple200: {
    name: 'purple200',
    color: '#f6e7f8'
  },
  purple300: {
    name: 'purple300',
    color: '#f7b6ff'
  },
  purple400: {
    name: 'purple400',
    color: '#f07aff'
  },
  purple500: {
    name: 'purple500',
    color: '#e14bf4'
  },
  purple600: {
    name: 'purple600',
    color: '#ae39c1'
  },
  red100: {
    name: 'red100',
    color: '#fff3f4'
  },
  red200: {
    name: 'red200',
    color: '#ffeaeb'
  },
  red300: {
    name: 'red300',
    color: '#ffc3c3'
  },
  red400: {
    name: 'red400',
    color: '#ff5853'
  },
  red500: {
    name: 'red500',
    color: '#f73631'
  },
  red600: {
    name: 'red600',
    color: '#e61e19'
  },
  saddlebrown100: {
    name: 'saddlebrown100',
    color: '#fff8f5'
  },
  saddlebrown200: {
    name: 'saddlebrown200',
    color: '#ffefe9'
  },
  saddlebrown300: {
    name: 'saddlebrown300',
    color: '#ffb498'
  },
  saddlebrown400: {
    name: 'saddlebrown400',
    color: '#ed7243'
  },
  saddlebrown500: {
    name: 'saddlebrown500',
    color: '#dc5d2d'
  },
  saddlebrown600: {
    name: 'saddlebrown600',
    color: '#ac4c28'
  },
  teal100: {
    name: 'teal100',
    color: '#e8fffc'
  },
  teal200: {
    name: 'teal200',
    color: '#d5f8f2'
  },
  teal300: {
    name: 'teal300',
    color: '#9af3e8'
  },
  teal400: {
    name: 'teal400',
    color: '#1cdbb9'
  },
  teal500: {
    name: 'teal500',
    color: '#00a693'
  },
  teal600: {
    name: 'teal600',
    color: '#008676'
  },
  white: {
    name: 'white',
    color: '#ffffff'
  },
  whitealpha10: {
    name: 'whitealpha10',
    color: 'rgba(#ffffff, 0.10)'
  },
  whitealpha15: {
    name: 'whitealpha15',
    color: 'rgba(#ffffff, 0.15)'
  },
  whitealpha20: {
    name: 'whitealpha20',
    color: 'rgba(#ffffff, 0.20)'
  },
  whitealpha50: {
    name: 'whitealpha50',
    color: 'rgba(#ffffff, 0.50)'
  },
  whitealpha60: {
    name: 'whitealpha60',
    color: 'rgba(#ffffff, 0.60)'
  },
  whitealpha70: {
    name: 'whitealpha70',
    color: 'rgba(#ffffff, 0.70)'
  },
  yellow100: {
    name: 'yellow100',
    color: '#fffcea'
  },
  yellow200: {
    name: 'yellow200',
    color: '#fff8d0'
  },
  yellow300: {
    name: 'yellow300',
    color: '#fff097'
  },
  yellow400: {
    name: 'yellow400',
    color: '#ffe651'
  },
  yellow500: {
    name: 'yellow500',
    color: '#fdd400'
  },
  yellow600: {
    name: 'yellow600',
    color: '#f2bd00'
  }
};

export { COLOR as default };
